import React from 'react'
import { BrandsData } from '@curvo/apollo'
import { SelectInput } from '@curvo/common-ui'
import { transformDataToOption } from '../AdvanceForm'
import DebounceInput from './DebounceInput'

const defaultProps = {}

type Props = Partial<typeof defaultProps> & {
  value: any
  onChange: (option: any) => void
}

const Brands: React.SFC<Props> = ({ value, onChange }) => (
  <DebounceInput>
    {({ searchText, onInputChange }) => (
      <BrandsData variables={{ searchText }}>
        {({ data, loading }) => (
          <SelectInput
            label="Brand"
            onInputChange={onInputChange}
            options={data && data.brands ? transformDataToOption(data.brands.edges) : []}
            loading={loading}
            value={value}
            onChange={onChange}
            asyncMode
          />
        )}
      </BrandsData>
    )}
  </DebounceInput>
)

Brands.defaultProps = defaultProps

export default React.memo(Brands)
